import { restApi } from '../../api';
import { BrandUser } from './brandUsers.types';

const PATH = 'brands/users';

export const findBrandUserByContextId = (contextId: string) =>
  restApi.get<BrandUser>(`${PATH}/${contextId}`);
